var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 50px"}},[_vm._m(0),_c('p',{staticClass:"about-ky-intro-p",domProps:{"innerHTML":_vm._s(_vm.xq.content)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-ky-titl-a"},[_c('h2',[_vm._v("科汇简介")]),_c('div',[_c('img',{attrs:{"src":require("../../../assets/img/botton/jj.png"),"alt":""}})])])
}]

export { render, staticRenderFns }